import React, { useState } from 'react';
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import MuiAppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { useDispatch } from 'react-redux';
import { USER_ACTIONS } from '../redux/actions';
import { useHistory } from 'react-router';
import LanguageSelector from './Selector/LanguageSelector';
import useLanguage from '../hooks/UseLanguage';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

const AppBar = ({onMenuToggle}) => {

  const classes = useStyles();

  const t = useLanguage()

  const dispatch = useDispatch()
  const userLogout = () => dispatch(USER_ACTIONS.userLogoutAction())

  const history = useHistory()

  const handleLogout = (e) => {
    userLogout()
    history.push("/")
  }

  return (
    <div className={classes.root}>
      <MuiAppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton onClick={onMenuToggle} edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {t('main.title')}
          </Typography>
          <LanguageSelector/>
          <Button onClick={handleLogout} color="inherit">{t("actions.logout")}</Button>
        </Toolbar>
      </MuiAppBar>
    </div>
  );
}

AppBar.defaultProps = {
  
};

AppBar.propTypes = {
  /**
   * Callback function to handle drawer menu toggle
   */
  onMenuToggle:PropTypes.func.isRequired
};

export default AppBar